<template>
	<div>
		<div class="con1 fl_r fl_j_b fl_a_c">
			<input :placeholder="placeholder" v-model="value" class="con1_l"></input>
			<div class="con1_r" @click="ssfn()"> 搜索 </div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "sousuo",
		props: {
			placeholder: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				value: ''
			};
		},
		methods: {
			ssfn () {
				this.$emit('ssfn', this.value);
			},
		}
	}
</script>
<style lang="less" scoped>
	.con1 {
		width: 1030px;
		margin: 0 auto;
		height: 70px;
		background: #FFFFFF;
		box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.1);
		border-radius: 42px 42px 42px 42px;

		.con1_l {
			flex: 1;
			height: 70px;
			margin-left: 40px;
			border: none;
			font-size: 16px;
		}

		.con1_r {
			width: 184px;
			height: 57px;
			background: #E10109;
			border-radius: 31px 31px 31px 31px;
			font-weight: 400;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 57px;
			text-align: center;
			margin-right: 8px;
		}
	}
</style>